const initialState = {
	sharesLeft: 3,
	sentInvitation: [],
	shareStatus: 'pending'
}

export default (state = initialState, action) => {
	switch (action.type) {
		case 'SET_SHARES_LEFT':
			return {
				...state,
				sharesLeft: action.payload
			}
		case 'ADD_SENT_INVIT':
			return {
				...state,
				sentInvitation: [...state.sentInvitation, ...action.payload]
			}
		case 'SET_SHARE_STATUS':
			return {
				...state,
				shareStatus: action.payload
			}
		default:
			return state
	}
}
